export const brandList = state => {
  let temps = state.lists
  let lists = []

  if (Array.isArray(temps) && temps.length) {
    temps.forEach(temp => {
      lists.push({
        id: temp.id,
        label: temp.name,
        competitor: temp.competitor == 1 ? 'Competitor' : 'Non Competitor'
      })
    })
  }

  return lists
}

export const gp = state => {
  let temps = state.groupPrincipals
  let lists = []

  if (Array.isArray(temps) && temps.length) {
    temps.forEach(t => {
      t.brands = []
      let brands = t.principals
      if (Array.isArray(brands) && brands.length) {
        t.brands = brands

        t.principals = brands.map(a => a.id)
      }
      lists.push(t)
    })
  }

  return lists
}

export const gpList = state => {
  let temps = state.groupPrincipals
  let lists = []

  if (Array.isArray(temps) && temps.length) {
    temps.forEach(temp => {
      lists.push({
        id: temp.id,
        label: temp.name
      })
    })
  }

  return lists
}
